export default __webpack_public_path__ + "static/media/LogoAJB.fce4c3ff.jpg";